// extracted by mini-css-extract-plugin
export default {"docTag":"DocTypeTag__docTag___bE_12"};